import styled from 'styled-components';

export const PropertyContainer = styled.div`
  width: 100%;
  float: center;
  margin-left: 75px;
`;
